import React from 'react';

import { GreekIslandsLandingPageContentViewModel } from '@api/v3';
import Typography from '@components/Typography';
import Markdown from '@components/utils/Markdown';

import {
  Banner,
  BannerContainer,
  Container,
  DecriptionItemContainer,
  DecriptionItemsContainer,
  DescriptionTextContainer,
  TopFAQItem,
  TopFAQItemContainer,
} from './styled';
import GreekIslands from './greek-islands';

const DesktopGateVisa = ({
  data,
}: {
  data?: GreekIslandsLandingPageContentViewModel;
}) => {
  return (
    <>
      <BannerContainer>
        <Banner
          src={data?.images?.[0]?.url || ''}
          alt={data?.images?.[0]?.alt || 'vira-vira'}
          fill
          priority
        />
      </BannerContainer>
      <Container>
        <TopFAQItemContainer>
          {data?.topFaqItems?.map((item, index) => (
            <TopFAQItem
              key={item.question}
              style={{
                textAlign: index === 2 || index === 3 ? 'left' : 'center',
              }} // needed to bypass markdown text alignment
            >
              <Typography variant='Title3' weight='Black' color='D400' as='div'>
                {item?.question}
              </Typography>
              <Typography
                variant='caption1'
                weight='Regular'
                color='D400'
                as='div'
              >
                <Markdown
                  text={item?.answer}
                  className='greek-islands-makrdown'
                />
              </Typography>
            </TopFAQItem>
          ))}
        </TopFAQItemContainer>
        <GreekIslands data={data?.descriptionAndImageItems?.[0]} />
        <DecriptionItemsContainer>
          {data?.descriptionItems?.map((item) => (
            <DecriptionItemContainer key={item.title}>
              <Typography variant='Title3' weight='Black' color='D400' as='div'>
                {item.title}
              </Typography>
              <DescriptionTextContainer>
                <Typography variant='caption1' weight='Regular' color='D400'>
                  <Markdown text={item.text} />
                </Typography>
              </DescriptionTextContainer>
            </DecriptionItemContainer>
          ))}
        </DecriptionItemsContainer>
      </Container>
    </>
  );
};
export default DesktopGateVisa;
